import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SchoolIcon from '@mui/icons-material/School';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { Mic, Newspaper, TrendingUp, VideoLibrary} from '@mui/icons-material';

export const logo = 'https://i.ibb.co/s9Qys2j/logo.png';

export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'Shorts', icon: <VideoLibrary />, },
  { name: 'Trending', icon: <TrendingUp/>, },
  { name: 'Live', icon: <LiveTvIcon/>, },
  { name: 'News', icon: <Newspaper />, },
  { name: 'Coding', icon: <CodeIcon />, },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Education', icon: <SchoolIcon />, },
  { name: 'Trailer', icon: <GraphicEqIcon />, },
  { name: 'Movie', icon: <OndemandVideoIcon />, },
  { name: 'Tamil Voice Over', icon: <Mic />, },
  { name: 'Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Live', icon: <LiveTvIcon />, },
  { name: 'Sport', icon: <FitnessCenterIcon />, },
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Beauty', icon: <FaceRetouchingNaturalIcon />, },
  { name: 'Comedy', icon: <TheaterComedyIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
];

export const demoThumbnailUrl = 'https://yt3.googleusercontent.com/xQCnnVIvPVWxzzMp3zBr_SBjo6XB1rSGsB4wad8vzoq8WaduVqBULTU2dZgfn5Erh2xWjjzQD4Y=s176-c-k-c0x00ffffff-no-rj';
export const demoChannelUrl = 'channel/UCTIuWYnWo-7CmYZqXD8WFRA';
export const demoVideoUrl = 'video/pnCwN4rI4Yc';
export const demoChannelTitle = 'Tamil Voice Over';
export const demoVideoTitle = 'TAMIL VOICE OVER is movie  critic , Review , voice-over channel in Tamil. Especially world movies .';
export const demoProfilePicture = 'https://yt3.googleusercontent.com/xQCnnVIvPVWxzzMp3zBr_SBjo6XB1rSGsB4wad8vzoq8WaduVqBULTU2dZgfn5Erh2xWjjzQD4Y=s176-c-k-c0x00ffffff-no-rj'